/**
 * The one Create modal's open request (docs/planning/global-create-modal.md).
 * Every create entry point opens it through `useOpenCreate`; the modal is
 * mounted once by Layout and reads this. Only the request lives here: the
 * modal's own step, picker and form state stay local to it.
 */

import { create } from 'zustand';
import type { CreateDestination } from '../components/features/create/destination/createDestination';

export interface CreateRequest {
  /** Analytics surface of the entry point (`CREATE_MENU_ITEM_CLICKED.surface`). */
  readonly surface: string;
  /**
   * Where things land. Absent: what is in view (`useDefaultCreateDestination`).
   * Snapshotted when the modal opens, so navigating behind it moves nothing.
   */
  readonly destination?: CreateDestination;
  /** Open straight at this create type (a registry id), skipping the choice. */
  readonly type?: string;
  /**
   * After a collection is created from the modal's New collection step. The
   * default opens the new collection; the canvas keeps you where you are.
   */
  readonly onCollectionCreated?: (collection: { readonly id: string }) => void;
}

interface CreateModalState {
  readonly request: CreateRequest | null;
  readonly open: (request: CreateRequest) => void;
  readonly close: () => void;
}

export const useCreateModalStore = create<CreateModalState>((set) => ({
  request: null,
  open: (request) => set({ request }),
  close: () => set({ request: null }),
}));
